export const hideLiveChat = () => {
  const liveChatContainer = document.querySelector("#chat-widget-container");

  if (liveChatContainer) {
    liveChatContainer.style.display = "none"
  } 
}